import { Component, OnInit, inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'app-signup-redirect',
  standalone: true,
  template: '<p>Redirecting to sign up...</p>'
})
export class SignupRedirectComponent implements OnInit {
  private authService = inject(AuthService);

  ngOnInit(): void {
    this.authService.loginWithRedirect({
      appState: { target: '/' },
      authorizationParams: { screen_hint: 'signup' }
    }).subscribe();
  }
}
